export interface AreaType2 {
  id: number;
  type: "country" | "borough" | "county" | "city";
  name: string;
}

export interface AreaType {
  id: number;
  type: string;
  name: string;
  removeAll?: boolean;
}

export interface MarkerType {
  lng: number;
  lat: number;
  counts: {
    yearCounts: number;
    lastReportedMonthCount: number;
  };
  showPopup?: boolean;
  isSearch?: boolean;
  isFirst?: boolean;
  location: string;
}

export const initArea = (): AreaType => ({
  name: "United Kingdom",
  type: "country",
  id: 82,
});

export interface GeojsonResponse {
  type: string;
  features: any[];
}

export enum LayerType {
  Borough = "borough",
  City = "city",
  District = "district",
  Country = "country",
}
